import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Guide } from 'src/app/core/interfaces/guide';
import { environment } from './../../../environments/environment';
import { Utils } from 'src/app/core/resources/utils';
import { GuideNovelty } from 'src/app/core/interfaces/guideNovelty';

@Injectable({
    providedIn: 'root'
})
export class GuideService {

    constructor(
        private _http: HttpClient,
        private _endpointResources: Endpoints,
        public utils: Utils
    ) {

    }

    getAllGuidesInCollection() {
        let url = environment.urlServerTeclogi + this._endpointResources.getGuides + 'state=Created' + '&pageKey=1&pageSize=50';
        return this._http.get<Guide[]>(
            url
        );
    }

    getGuide(guideId: string) {
        // let url = environment.urlServerTeclogi + this._endpointResources.getGuideFalabella + guideId + '&pageKey=1&pageSize=20';
        let url = environment.urlServerTeclogi + this._endpointResources.getGuideFalabella + guideId;
        return this._http.get<Guide[]>(
            url
        );
    }

    getAllGuidesInDistribution() {
        let url = environment.urlServerTeclogi + this._endpointResources.getGuides + 'state=In warehouse' + '&pageKey=1&pageSize=50';
        return this._http.get<Guide[]>(
            url
        );
    }

    getGuidesSelected(guides, property?) {
        if (property) {
            return _.filter(guides, function (guide) {
                return guide.checked >= true;
            }).map(function (guide) {
                return guide[property];
            });
        } else {
            return _.filter(guides, function (guide) {
                return guide.checked >= true;
            });
        }
    }

    getMultipleGuidesPDF(guides, isGuide?: boolean) {
        let url = environment.urlServerTeclogi + this._endpointResources.getMultipleGuidesPDF;
        if (this.utils.isDefined(isGuide)) {
            url = url + "&isGuide=" + isGuide;
        }
        return this._http.post(
            url,
            guides,
            {
                observe: 'response',
                responseType: 'blob'
            }
        ).pipe(
            timeout(300000)
        );
    }

    addNoveltyToGuide(guideId: string, novelty: { novelty: GuideNovelty, evidences: string[] }) {
        let url = `${environment.urlServerTeclogi}${this._endpointResources.addNoveltyToGuide}?guideId=${guideId}`;
        return this._http.post(url, novelty);
    }

    // para editar una guia
    updateGuides(guides: Guide[], cargoId: string) {
        let url = `${environment.urlServerTeclogi}${this._endpointResources.updateGuide}?cargoId=${cargoId}`;
        return this._http.put(url, guides);
    }

    changeGuideStatusDelete(guidesIds: string[], cargoId: string) {
        let url = `${environment.urlServerTeclogi}${this._endpointResources.changeGuideStatusDelete}?cargoId=${cargoId}`;
        return this._http.put(url, guidesIds);
    }
}